var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import { SiteLogo } from '../components';
import { LogoContext } from "../components/context/logo-context";
export var useLogo = function useLogo(variant) {
  return function (props) {
    var Logo = React.useContext(LogoContext) || SiteLogo;

    if (!Logo) {
      return null;
    }

    return React.createElement(Logo, __assign({
      variant: variant
    }, props));
  };
};